import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { castArray } from 'lodash-es';
import type { FC } from 'react';
import { FormCheckboxCheckboxStyle, FormCheckboxStyle } from './FormCheckbox.styles';
import type { FormCheckboxProps } from './FormCheckbox.types';

const FormCheckbox: FC<FormCheckboxProps> = ({
  checkboxProps,
  labelText,
  isReadOnly,
  isFieldOptional,
  ...rest
}) => {
  const renderLabelContent = () => {
    if (typeof labelText === 'string')
      return (
        <Typography>
          {labelText}

          {isFieldOptional && (
            <Typography
              component="span"
              display="inline"
              ml={1}
              sx={{
                color: (theme) => theme.palette.customColors.darkGray,
              }}
            >
              (optional)
            </Typography>
          )}
        </Typography>
      );

    return labelText;
  };

  return (
    <FormControlLabel
      {...rest}
      data-test={rest['data-test']}
      control={
        <Checkbox
          {...checkboxProps}
          sx={[FormCheckboxCheckboxStyle, ...castArray(checkboxProps?.sx)]}
          disableRipple={checkboxProps?.disableRipple || isReadOnly}
          disabled={checkboxProps?.disabled || isReadOnly}
          inputProps={{
            ...checkboxProps?.inputProps,
            readOnly: checkboxProps?.inputProps?.readOnly || isReadOnly,
          }}
        />
      }
      label={renderLabelContent()}
      sx={[FormCheckboxStyle, ...castArray(rest.sx)]}
    />
  );
};
export default FormCheckbox;
